import React from 'react';

const Team = () => {
  return (
    <div>
      <div className='team-container'>
        Our team
        <div className='team-member'>
          <div className='team-1'>
            <a href='https://www.linkedin.com/in/ankita12sharma/' target='_blank' rel='noopener noreferrer'>
              <img src='/Ankita Mam.png' alt='Faculty' className='ankitamam' />
              <div style={{ lineHeight: '2px', textAlign: 'center' }}>
                <p style={{ fontSize: '0.5rem' }}>Er. Ankita Sharma</p>
                <p style={{ fontSize: '0.5rem' }}>Club Counselor</p>
              </div>
            </a>
          </div>
          <div className='team-2'>
            <a href='https://www.linkedin.com/in/harkirat-singh-bhullar-59611210b/' target='_blank' rel='noopener noreferrer'>
              <img src='/Harkirat Sir.png' alt='Faculty' className='ankitamam' />
              <div style={{ textAlign: 'center', lineHeight: '2px' }}>
                <p style={{ fontSize: '0.5rem' }}>Er. Harkirat Singh Bhullar</p>
                <p style={{ fontSize: '0.5rem' }}>Faculty Advisor</p>
              </div>
            </a>
          </div>
          <div className='team-1'>
            <a href='https://www.linkedin.com/in/yogiraj-bhale-a0a63977/' target='_blank' rel='noopener noreferrer'>
              <img src='/Yogirajsir.jpg' alt='Faculty' className='ankitamam' />
              <div style={{ lineHeight: '2px', textAlign: 'center' }}>
                <p style={{ fontSize: '0.5rem' }}>Er. Yogiraj Bhale</p>
                <p style={{ fontSize: '0.5rem' }}>Co-Faculty Advisor</p>
              </div>
            </a>
          </div>
          <div className='team-2'>
            <a href='https://www.linkedin.com/in/atul-raj-095322229/' target='_blank' rel='noopener noreferrer'>
              <img src='/Atul.png' alt='Faculty' className='ankitamam' />
              <div style={{ textAlign: 'center', lineHeight: '2px' }}>
                <p style={{ fontSize: '0.5rem' }}>Atul Raj</p>
                <p style={{ fontSize: '0.5rem' }}>Secretary</p>
              </div>
            </a>
          </div>
        </div>

        <div className='team-member'>
          <div className='team-1'>
            <a href='https://www.linkedin.com/in/shivansh-tiwari-48894924a/' target='_blank' rel='noopener noreferrer'>
              <img src='/Shivansh-CAC.png' alt='Faculty' className='ankitamam' />
              <div style={{ lineHeight: '2px', textAlign: 'center' }}>
                <p style={{ fontSize: '0.5rem' }}>Shivansh Tiwari</p>
                <p style={{ fontSize: '0.5rem' }}>Treasurer</p>
              </div>
            </a>
          </div>
          <div className='team-2'>
            <a href='https://www.linkedin.com/in/siddharthsharma1374?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app ' target='_blank' rel='noopener noreferrer'>
              <img src='/Siddharth.png' alt='Faculty' className='ankitamam' />
              <div style={{ textAlign: 'center', lineHeight: '2px' }}>
                <p style={{ fontSize: '0.5rem' }}>Siddharth</p>
                <p style={{ fontSize: '0.5rem' }}>Multi-Media Executive</p>
              </div>
            </a>
          </div>
          <div className='team-1'>
            <a href='https://www.linkedin.com/in/abhishek-kumar-pandey-aabb0424b/' target='_blank' rel='noopener noreferrer'>
              <img src='/Abhishek.jpg' alt='Faculty' className='ankitamam' />
              <div style={{ lineHeight: '2px', textAlign: 'center' }}>
                <p style={{ fontSize: '0.5rem' }}>Abhishek Kumar Pandey</p>
                <p style={{ fontSize: '0.5rem' }}>Record Executive</p>
              </div>
            </a>
          </div>
          <div className='team-2'>
            <a href='https://www.linkedin.com/in/chirag-kalucha-42a839266/' target='_blank' rel='noopener noreferrer'>
              <img src='/Chirag.jpg' alt='Faculty' className='ankitamam' />
              <div style={{ lineHeight: '2px', textAlign: 'center' }}>
                <p style={{ fontSize: '0.5rem' }}>Chirag Kalucha</p>
                <p style={{ fontSize: '0.5rem' }}>Event & Program Executive</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;
